module.exports = __webpack_public_path__ + "img/fruitveg-segment.a2fcd66e.png";